<template>
  <div id="collectionA">
    <div class="bg-img"></div>

    <div class="content middle collection">
      <div class="cell">
        <div class="container relative">
          <div class="row">
            <div class="col-xs-12">
              <div class="row series_selection">
                <div :class="'col-xs-3 ' + key" v-for="(value, key) in series" :key="key">
                  <img :src="value.img" />
                  <div
                    class="button-b click font20 text-center"
                    :class="selected_series == key ? 'active shown-o' : textColor"
                    @click="selected_series = key">
                    {{ value.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16" @click="next()">
      <span class="orange click inlineb w10">
        NEXT
        <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";

export default {
  name: "Collection",
  data() {
    return {
      selected_series: "alba",
      series: {
        blackjack: {
          img : "images/collection/blackjack/BLACKJACK.png",
          label: "BLACK JACK",
        },
        aria: {
          img : "images/collection/aria/ARIA.png",
          label: "ARIA",
        },
        alba: {
          img: "images/collection/alba/ALBA.png",
          label: "ALBA",
        },
        axes: {
          img: "images/collection/axes/AXES.png",
          label: "AXES",
        }
      },
      textColor: 'white'
    };
  },
  created: function () {
    this.$parent.headerW();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
  },
  methods: {
    next() {
      if (this.selected_series == "blackjack") {
        this.$store.state.artwork = {
          type: "blackjack",
          frameColor: "so",
          keyColor: "so",
          format: "single",
          buttonFormat: "square",
          layout: "K4",
          iconSize: 8,
          protocol: "",
          productLine: "Signature",
          name: "BLACK JACK artwork",
          productCode: "",
          fontType: "Avenir",
          alignment: "topcenter",
          layoutStyle: "iconOnly",
          content: []
        };
      } else if (this.selected_series == "alba") {
        this.$store.state.artwork = {
          type: "alba",
          frameColor: "yorkBlack",
          keyColor: "yorkBlack",
          format: "single",
          layout: "K4",
          rightLayout: "M1",
          tripleRightLayout: "SK",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          protocol: "",
          productLine: "Signature",
          name: "An ALBA artwork",
          productCode: "",
          fontType: "Avenir",
          alignment: "topleft",
          rightAlignment: "topleft",
          tripleRightAlignment: "topleft",
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
          content: [],
          rightContent: [],
          tripleRightContent: [],
        };
      } else if (this.selected_series == "aria") {
        this.$store.state.artwork = {
          type: "aria",
          frameColor: "yorkBlack",
          format: "single",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          content: [],
          rightContent: [],
          tripleRightContent: [],
          protocol: "",
          productLine: "Signature",
          name: "An ARIA artwork",
          productCode: "",
          fontType: "Avenir",
          alignment: "topLeft",
          rightAlignment: "topLeft",
          tripleRightAlignment: "topLeft",
          layout: "L12",
          rightLayout: "M1",
          tripleRightLayout: "SK",
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
        };
      } else if (this.selected_series == "axes") {
        this.$store.state.artwork = {
          type: "axes",
          frameColor: "yorkBlack",
          format: "single",
          iconSize: 8,
          rightIconSize: 8,
          tripleRightIconSize: 8,
          fontSize: 2.5,
          rightFontSize: 2.5,
          tripleRightFontSize: 2.5,
          content: [],
          rightContent: [],
          tripleRightContent: [],
          protocol: "",
          productLine: "Signature",
          name: "An AXES artwork",
          productCode: "",
          fontType: "Avenir",
          alignment: "topLeft",
          rightAlignment: "topLeft",
          tripleRightAlignment: "topLeft",
          layout: "N34",
          rightLayout: "DR",
          tripleRightLayout: "SK",
          layoutStyle: "iconOnly",
          rightLayoutStyle: "iconOnly",
          tripleRightLayoutStyle: "socket",
        };
      }
      this.$store.commit("getProductCode");
      this.$store.commit("getContent");
      this.$store.commit("getRightContent");
      this.$store.commit("getTripleRightContent");
      this.$router.push({ path: "/collection/config" });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name != "addproduct-keypad") {
        vm.$store.state.newArtworkToProductId = null
      }
    });
  },
};
</script>

<style lang="css">
.header.black {
  border-bottom: none;
}
</style>
